// extracted by mini-css-extract-plugin
export default {"FormButtonsManager":"styles_FormButtonsManager__uSbgr"};